import { ReactNode } from 'react';

import { Checkbox, Heading } from '../../shared/ui';
import { ClientTaskBlock } from '../../components/journal/client-assignment/client-task-block';
import { useToolAssignment } from '../../components/journal/client-assignment/context';

export interface IJournalToolsInfo {
  title: string;
  /** Идентификатор в отправке клиенту; без него секция не участвует в отправке. */
  assignmentId?: string;
  children?: ReactNode;
}

export const JournalToolsInfo = ({ title, assignmentId, children }: IJournalToolsInfo) => {
  const assignment = useToolAssignment(assignmentId, title);

  // Вне вкладки отправки секция остаётся простым заголовком с содержимым.
  if (!assignment.isActive) {
    return (
      <div className="mb-[20px]">
        <Heading size="lg" className="mb-[10px]">
          {title}
        </Heading>
        {children}
      </div>
    );
  }

  return (
    <section className="mb-[18px] overflow-hidden rounded-card border border-line bg-white">
      <div className="flex flex-wrap items-start justify-between gap-4 p-[20px_22px_10px]">
        <Heading size="lg">{title}</Heading>
        {assignment.canSend && (
          <div className="shrink-0 rounded-control border border-line p-[8px_14px]">
            <Checkbox
              size="sm"
              checked={assignment.isIncluded}
              onChange={assignment.onToggle}
              disabled={assignment.isSent}
              label="Выбрать для клиента"
            />
          </div>
        )}
      </div>

      <div className="px-[22px] pb-5">{children}</div>

      {assignment.canSend && (
        <ClientTaskBlock
          label={assignment.taskLabel}
          value={assignment.task}
          onChange={assignment.onTaskChange}
          maxLength={assignment.taskMaxLength}
          disabled={assignment.isSent}
        />
      )}
    </section>
  );
};
